import React from 'react';
import { Tabs } from 'antd';
import './CustomTab.scss';

const CustomTab = ({ tabItems, activeTab, setActiveTab, useItemKey = false }) => {
        return (
                <div className="w-full overflow-x-auto ml-4">
                        <Tabs
                                rootClassName="custom-tabs"
                                activeKey={activeTab}
                                onChange={(key) => setActiveTab(key)}
                                tabPosition="top"
                                type="line"
                                items={tabItems.map((tab, index) => {
                                        const key = useItemKey
                                                ? tab.key?.toString()
                                                : index.toString();
                                        return {
                                                key,
                                                label: (
                                                        <div
                                                                className={`px-4 transition-colors ${
                                                                        activeTab === key
                                                                                ? 'text-[#2C3F7E] font-inter font-semibold'
                                                                                : 'text-[#667085] font-inter font-semibold'
                                                                }`}
                                                        >
                                                                {tab.label}
                                                        </div>
                                                ),
                                                children: <div className="">{tab.content}</div>,
                                        };
                                })}
                        />
                </div>
        );
};

export default CustomTab;
